import React, { Component } from "react";
import { Accordion, AccordionItem } from "@sainsburys-tech/fable";
import { forkJoin, combineLatest } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { componentFromStream } from "recompose";
import withLoadingAndErrorHandling from "../../utils/reactive/wrapPageApiCall.js";
import PropTypes from "prop-types";
import moment from "moment";
import PageTitle from "../PageTitle";
import StoresTable from "./StoresTable";
import Badge from "../Badge";

class LightingStatusPage extends Component {
  render() {
    return (
      <PageTitle title="Lighting status">
        <div>
          <section>
            <h3>Lighting status</h3>
            <p>Last updated {moment().format("HH:mm, Do MMM YYYY")}</p>
            <p className="fable:mb-0">
              <span className="fable:mr-4">
                <Badge title="ELS" />
              </span>{" "}
              indicates a store in Early Life Support (commissioned in the last
              14 days)
            </p>
          </section>
          <Accordion>
            <AccordionItem
              isDefaultOpen
              id="accordion-item-commissioning"
              label="Stores still in commissioning mode"
              className="cb-c-lighting-status-page__drop-shadow"
            >
              <StoresTable
                stores={this.props.status.storesInCommissioningMode}
              />
            </AccordionItem>
            <AccordionItem
              isDefaultOpen
              id="accordion-item-missing-heartbeats"
              label="Stores with missing heartbeats"
              className="cb-c-lighting-status-page__drop-shadow"
            >
              <StoresTable
                stores={this.props.status.storesWithMissingHeartbeats}
              />
            </AccordionItem>
            <AccordionItem
              isDefaultOpen
              id="accordion-item-managers-override"
              label="Stores with Managers Override enabled"
              className="cb-c-lighting-status-page__drop-shadow"
            >
              <StoresTable
                stores={this.props.status.storesWithManagersOverride}
              />
            </AccordionItem>
          </Accordion>
        </div>
      </PageTitle>
    );
  }
}

LightingStatusPage.propTypes = {
  status: PropTypes.shape({
    storesInCommissioningMode: PropTypes.arrayOf(
      PropTypes.shape({
        storeId: PropTypes.string,
        name: PropTypes.string,
        lastGatewayHeartbeat: PropTypes.string,
        firstCommissioned: PropTypes.string,
        latestAcknowledgedSchedule: PropTypes.string
      })
    ),
    storesWithMissingHeartbeats: PropTypes.arrayOf(
      PropTypes.shape({
        storeId: PropTypes.string,
        name: PropTypes.string,
        lastGatewayHeartbeat: PropTypes.string,
        firstCommissioned: PropTypes.string,
        latestAcknowledgedSchedule: PropTypes.string
      })
    ),
    storesWithManagersOverride: PropTypes.arrayOf(
      PropTypes.shape({
        storeId: PropTypes.string,
        name: PropTypes.string,
        lastGatewayHeartbeat: PropTypes.string,
        firstCommissioned: PropTypes.string,
        latestAcknowledgedSchedule: PropTypes.string
      })
    )
  })
};

export default componentFromStream(props$ => {
  return withLoadingAndErrorHandling(() =>
    combineLatest([props$]).pipe(
      mergeMap(([props]) => forkJoin([props.getStatus()])),
      map(([status]) => <LightingStatusPage status={status} />)
    )
  );
});
